import api from "./api";
import Utils from "@/common/Utils";

class LanguageService {
  getLanguageListInSetting(params) {
    return api
      .post("/language/getLanguageListInSetting", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLanguageList(params) {
    return api
      .post("/language/getLanguageList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLanguageVersionList(params) {
    return api
      .post("/language/getLanguageVersionList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertLanguageList(params) {
    return api
      .post("/language/insertLanguageList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }
}

export default new LanguageService();
